import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '01',
      name: i18n.t('tipos.paid_form.cash'),
    },
    {
      id: '02',
      name: i18n.t('tipos.paid_form.direct_debit'),
    },
    {
      id: '03',
      name: i18n.t('tipos.paid_form.receipt'),
    },
    {
      id: '04',
      name: i18n.t('tipos.paid_form.transfer'),
    },
    {
      id: '05',
      name: i18n.t('tipos.paid_form.accepted_bill'),
    },
    {
      id: '06',
      name: i18n.t('tipos.paid_form.documentary_credit'),
    },
    {
      id: '07',
      name: i18n.t('tipos.paid_form.award_contract'),
    },
    {
      id: '08',
      name: i18n.t('tipos.paid_form.bill_of_exchange'),
    },
    {
      id: '09',
      name: i18n.t('tipos.paid_form.to_order'),
    },
    {
      id: '10',
      name: i18n.t('tipos.paid_form.not_to_order'),
    },
    {
      id: '11',
      name: i18n.t('tipos.paid_form.check'),
    },
    {
      id: '12',
      name: i18n.t('tipos.paid_form.replacement'),
    },
    {
      id: '13',
      name: i18n.t('tipos.paid_form.specials'),
    },
    {
      id: '14',
      name: i18n.t('tipos.paid_form.compensation'),
    },
    {
      id: '15',
      name: i18n.t('tipos.paid_form.postal_money_order'),
    },
    {
      id: '16',
      name: i18n.t('tipos.paid_form.certified_check'),
    },
    {
      id: '17',
      name: i18n.t('tipos.paid_form.bank_check'),
    },
    {
      id: '18',
      name: i18n.t('tipos.paid_form.on_delivery'),
    },
    {
      id: '19',
      name: i18n.t('tipos.paid_form.by_card'),
    },
  ]
}

export function FORMAS_DE_PAGO (state) {
  return configHelper.getConfig(state, 'FORMAS_DE_PAGO', GenerateConfig)
}
